import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import {
    IClassConfig,
    IconsConfig,
    MenuSettingsConfiguration,
    SettingMenuEmitEventType,
    SettingsDataValues,
    SettingsValueType,
    SingleSettingConfig,
} from '../types';

/*
 * gestisce un singolo sotto menu per il componente padre se-search-settings
 *
 * per gestire i suffix prefix nel template considerare gli attributi condizionali
 * <div [attr.matPrefix]="condition" [attr.matSuffix]="condition">
 * */
@Component({
    selector: 'se-settings-menu',
    templateUrl: './se-settings-menu.component.html',
    styleUrls: ['./se-settings-menu.component.scss'],
})
export class SeSettingsMenuComponent implements OnInit {
    @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

    @Input()
    tooltipDelay = 500;

    @Input()
    menuName: string = '';
    @Input()
    nameTranslationKey: string = '';

    @Input()
    set menuSettings(value: MenuSettingsConfiguration[]) {
        this._menuSettings = [...value];
    }

    @Input()
    menuDataValues: SettingsDataValues = {};

    _menuSettings: MenuSettingsConfiguration[] = [];

    get menuSettings(): MenuSettingsConfiguration[] {
        return this._menuSettings;
    }

    readonly DEFAULT_MENU_DELAY: number = 100;

    isOverMenu: boolean = false;
    isOverTrigger: boolean = false;

    @Output()
    settingChanged = new EventEmitter<SettingMenuEmitEventType>();

    constructor() {
    }

    classConfigToList = (classConfig: IClassConfig[], value: SettingsValueType): string[] =>
        classConfig.filter((item) => item.showMatchValue === value).map((item) => item.className);

    mouseOverTriggerButton = ($event: MouseEvent) => {
        this.isOverTrigger = true;
        this.trigger.openMenu();
    };

    /*
    * il codice commentato qui sotto per ora non serve essendoci sempre un solo sottomenu
    * quando ci dovranno essere piu menu per evitare che si sovrappongano scommentare */
    mouseLeaveTriggerButton = ($event: MouseEvent) => {
        this.isOverTrigger = false;
        // setTimeout(() => {
        //     if (!this.isOverMenu) this.trigger.closeMenu();
        // }, this.DEFAULT_MENU_DELAY);
    };
    mouseLeaveMenu = ($event: Event) => {
        this.isOverMenu = false;

        // setTimeout(() => {
        //     /*serve per non farlo chiudere on hover tooltip
        //     (il tooltip nel dom non e` figlio dell'elemento a cui e` legato per cui hover sul tooltip risulta un mouseleave sul menu) */
        //     if ($event?.toElement.classList.contains('mdc-tooltip')) {
        //         return;
        //     }
        //     if (!this.isOverTrigger) this.trigger.closeMenu();
        // }, this.DEFAULT_MENU_DELAY);
    };

    mouseOverMenu = ($event: MouseEvent) => (this.isOverMenu = true);

    handleChangeInput = ($event: Event, propName: string, menuItem: SingleSettingConfig) => {
        $event.stopPropagation();
        $event.preventDefault();
        const target = $event.target as HTMLInputElement;
        this.settingChanged.emit({ settingName: menuItem.name, propName, value: target.value });
    };

    handleIconClick = ($event: MouseEvent, iconConf: IconsConfig, propName: string, menuItem: SingleSettingConfig) => {
        this.settingChanged.emit({
            settingName: menuItem.name,
            propName,
            value: iconConf.showMatchValue,
        });
    };

    handleChangeToggle = ($event: MatSlideToggleChange, propName: string, item: SingleSettingConfig) => {
        this.settingChanged.emit({ settingName: item.name, propName, value: $event.checked });
    };
    handleMenuClick = ($event: MouseEvent) => {
        $event.stopPropagation();
    };

    ngOnInit(): void {
    }
}
